import { z } from 'zod';
import type { DigitilesExtension } from '../catalog';
import { RandomTile } from '@/models/tiles/RandomTile';
import { RandomNode } from '@/models/logic/nodes/RandomNode';
import { standardBuildAndConnect } from '@/models/logic/utils';
import { CircuitType } from '@/schemas/common';
import { Signal } from '@/models/data/Signal';

export const RANDOM_TYPE = 'extension:digitiles.random/random' as const;
const legacy = new RandomTile();
const tile = {
  ...legacy,
  type: RANDOM_TYPE,
  stateSchema: z.object({
    prevInput: z.nativeEnum(Signal).nullable(),
    lastOutput: z.nativeEnum(Signal),
  }),
  graphics: { ...legacy.graphics, type: RANDOM_TYPE },
  buildAndConnectNodes: (data: Parameters<typeof standardBuildAndConnect>[1]) =>
    standardBuildAndConnect(RANDOM_TYPE, data, tile),
};

/** Legacy Random/RANDOM registrations stay available for existing saved circuits. */
export const randomExtension: DigitilesExtension = {
  id: 'digitiles.random',
  name: 'Random',
  version: '1.0.0',
  description:
    'A random bit at startup and each rising left input edge. Holds its output between edges. Existing Random tiles remain compatible.',
  tiles: [{ definition: tile, circuits: [CircuitType.ChipLogic] }],
  nodes: [
    {
      ...RandomNode,
      type: RANDOM_TYPE,
      stateSchema: z.object({ prevInput: z.boolean(), currentOutput: z.boolean() }),
    },
  ],
};
